__turbopack_context__.v({
  "closeButton": "GlzDRq_closeButton",
  "controls": "GlzDRq_controls",
  "description": "GlzDRq_description",
  "root": "GlzDRq_root",
  "rootTextAlignCenter": "GlzDRq_rootTextAlignCenter",
  "title": "GlzDRq_title",
});
